import { useState, useEffect, useRef } from "react";
import useAdminDataStore, {
  selectCurrentGroupId,
  selectAllGroups,
} from "../../../../../store/adminData/adminData";
import useUserStore, {
  selectUserDetails,
} from "../../../../../store/user/user";
import { fbGetGroupPaymentDetails } from "../../../../../services/firebaseService/endPoints/admin/groupConfig";
import {
  db,
  storage,
} from "../../../../../services/firebaseService/connection";
import { getMetadata, ref } from "firebase/storage";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { getLocations } from "../../../../../services/firebaseService/endPoints/admin/content";
import { verifyStripeAccountId } from "../../../../../utils/errors";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  uploadTicketImage,
  fbGetTicketDetails,
} from "../../../../../services/firebaseService/endPoints/admin/tickets";
import Ticket from "../../../../../models/admin/Ticket";
import { chantApi } from "../../../../../utils/chantApi";
import logger from "../../../../../utils/logger";
import Axios from "../../../../../services/apiFootballService/connection";
import { ticketDetailsTemplate, TICKET_TYPES, PROCESSING_FEE_TYPES } from "./constants";

dayjs.extend(utc);

const useCreateTicket = (props) => {
  // Merged from CreateTicketWithData wrapper
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];
  const user = useUserStore(selectUserDetails); // eslint-disable-line no-unused-vars
  const clubId = adminData?.data?.clubId;
  const groupName = adminData?.data?.groupName; // eslint-disable-line no-unused-vars

  // Constructor state
  const [type, setType] = useState("");
  const [location, setLocation] = useState({});
  const [matchId, setMatchId] = useState("");
  const [title, setTitle] = useState(""); // eslint-disable-line no-unused-vars
  const [eventDate, setEventDate] = useState(null);
  const [saleEndDate, setSaleEndDate] = useState(null);
  const [eventDescription, setEventDescription] = useState("");
  const [lastDownloadOn, setLastDownloadOn] = useState(0); // eslint-disable-line no-unused-vars
  const [checkMatchRequired, setCheckMatchRequired] = useState(true);
  const [previewVisible, setPreviewVisible] = useState(false); // eslint-disable-line no-unused-vars
  const [previewImage, setPreviewImage] = useState(""); // eslint-disable-line no-unused-vars
  const [section, setSection] = useState("");
  const [quantity, setQuantity] = useState(null);
  const [showRequireMembers, setShowRequireMembers] = useState(true); // eslint-disable-line no-unused-vars
  const [price, setPrice] = useState(null);
  const [limit, setLimit] = useState(null);
  const [passLimit, setPassLimit] = useState(null);
  const [email, setEmail] = useState(false);
  const [barcode, setBarcode] = useState(false); // eslint-disable-line no-unused-vars
  const [requireMember, setRequireMember] = useState(false); // eslint-disable-line no-unused-vars
  const [stripeAddress, setStripeAddress] = useState("");
  const [notifyOnPublish, setNotifyOnPublish] = useState(true);
  const [errorInForm, setErrorInForm] = useState({
    isError: false,
    visible: false,
    message: "",
  });
  const [noOfCheckins, setNoOfCheckins] = useState(0); // eslint-disable-line no-unused-vars
  const [soldTickets, setSoldTickets] = useState(0);
  const [loadingDocument, setLoadingDocument] = useState(
    !!props.router.params.id,
  );
  const [editMode, setEditMode] = useState(!!props.router.params.id); // eslint-disable-line no-unused-vars
  const [editConfiguration, setEditConfiguration] = useState({
    imageChanged: false,
  });
  const [ticketTypes, setTicketTypes] = useState(TICKET_TYPES); // eslint-disable-line no-unused-vars
  const [processingFeeTypes, setProcessingFeeTypes] = useState(PROCESSING_FEE_TYPES); // eslint-disable-line no-unused-vars
  const [ticketLimit, setTicketLimit] = useState([]);
  const [matchList, setMatchList] = useState([]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [match, setMatch] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMatches, setLoadingMatches] = useState(true);
  const [ticketId, setTicketId] = useState(props.router.params.id); // eslint-disable-line no-unused-vars
  const [eventName, setEventName] = useState("");
  const [oldTicketsCount, setOldTicketsCount] = useState(0);
  const [row, setRow] = useState("TBD"); // eslint-disable-line no-unused-vars
  const [seats, setSeats] = useState("TBD"); // eslint-disable-line no-unused-vars
  const [eventCode, setEventCode] = useState("abcdef"); // eslint-disable-line no-unused-vars
  const [collectedAmount, setCollectedAmount] = useState(0); // eslint-disable-line no-unused-vars
  const [remainingTickets, setRemainingTickets] = useState(0);
  const [broughtBy, setBroughtBy] = useState([]); // eslint-disable-line no-unused-vars
  const [errorQuantity, setErrorQuantity] = useState(false); // eslint-disable-line no-unused-vars
  const [imageFile, setImageFile] = useState(undefined);
  const [imageList, setImageList] = useState([]);
  const [tickets, setTickets] = useState([
    JSON.parse(JSON.stringify(ticketDetailsTemplate)),
  ]);
  const [showForFans, setShowForFans] = useState(false);
  const [showOnWeb, setShowOnWeb] = useState(false);
  const [showForMembers, setShowForMembers] = useState(true);
  const [processingFee, setProcessingFee] = useState("");
  const [groupTerms, setGroupTerms] = useState("");
  const [receiptDescription, setReceiptDescription] = useState("");
  const [allLocations, setAllLocations] = useState([]);
  const [ticketDeliveryMethodApp, setTicketDeliveryMethodApp] = useState("");
  const [ticketDeliveryMethodWeb, setTicketDeliveryMethodWeb] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [refundTerms, setRefundTerms] = useState("");
  const [ticketLink, setTicketLink] = useState(""); // eslint-disable-line no-unused-vars

  // Dynamic state fields
  const [eventTime, setEventTime] = useState(undefined); // eslint-disable-line no-unused-vars
  const [saleEndTime, setSaleEndTime] = useState(undefined); // eslint-disable-line no-unused-vars
  const [layout2, setLayout2] = useState(undefined);
  const [oldImageName, setOldImageName] = useState(undefined);
  const [loadingPercentage, setLoadingPercentage] = useState(undefined); // eslint-disable-line no-unused-vars

  const isFirstRunRef = useRef(true);

  // ─── Helper: collect all state for Ticket model ───
  const collectFormState = () => ({
    type,
    location,
    matchId,
    title,
    eventDate,
    saleEndDate,
    eventDescription,
    lastDownloadOn,
    checkMatchRequired,
    previewVisible,
    previewImage,
    section,
    quantity,
    showRequireMembers,
    price,
    limit,
    passLimit,
    email,
    barcode,
    requireMember,
    stripeAddress,
    notifyOnPublish,
    errorInForm,
    noOfCheckins,
    soldTickets,
    loadingDocument,
    editMode,
    editConfiguration,
    ticketTypes,
    processingFeeTypes,
    ticketLimit,
    matchList,
    acceptedTerms,
    match,
    isLoading,
    loadingMatches,
    ticketId,
    eventName,
    oldTicketsCount,
    row,
    seats,
    eventCode,
    collectedAmount,
    remainingTickets,
    broughtBy,
    errorQuantity,
    imageFile,
    imageList,
    tickets,
    showForFans,
    showOnWeb,
    showForMembers,
    processingFee,
    groupTerms,
    receiptDescription,
    allLocations,
    ticketDeliveryMethodApp,
    ticketDeliveryMethodWeb,
    contactEmail,
    refundTerms,
    ticketLink,
    eventTime,
    saleEndTime,
    layout2,
    oldImageName,
    loadingPercentage,
    groupId: currentGroup,
    eventDate: dayjs(eventDate).unix(),
    eventTime: dayjs(eventDate).unix(),
    saleEndDate: dayjs(saleEndDate).unix(),
    saleEndTime: dayjs(saleEndDate).unix(),
  });

  // ─── Handlers ───

  const uploadAction = (file) => {
    setImageFile(file);
  };

  const handleImageChange = ({ fileList }) => {
    let result = {};
    if (fileList.length === 0) {
      result.imageFile = {};
    } else {
      result.imageFile = fileList[0].originFileObj;
    }

    if (editMode && !editConfiguration.imageChanged) {
      let newEditConfiguration = Object.assign({}, editConfiguration);
      newEditConfiguration.imageChanged = true;
      setEditConfiguration(newEditConfiguration);
    }

    result.imageList = fileList;

    setImageFile(result.imageFile);
    setImageList(result.imageList);
  };

  const handleErrorMessageClose = () => {
    setErrorInForm((prevErrorInForm) => {
      const updated = { ...prevErrorInForm };
      updated.visible = false;
      return updated;
    });
  };

  const handleSubmit = async (e, publishStatus) => {
    try {
      e.preventDefault();

      if (acceptedTerms === true) {
        const totalPrice = tickets?.reduce((acc, curr) => {
          return (acc =
            acc + Number(curr?.memberPrice) + Number(curr?.nonMemberPrice));
        }, 0);
        if (
          totalPrice > 0 &&
          !verifyStripeAccountId(
            adminData?.data?.paymentDetails?.stripeAccountId,
          )
        ) {
          return;
        }

        setIsLoading(true);

        if (!matchId || matchId?.length === 0) {
          if (
            !(
              (Array.isArray(imageList) && imageList.length !== 0) ||
              imageFile !== undefined
            )
          ) {
            window.scrollTo(0, 0);
            setErrorInForm({
              isError: true,
              visible: true,
              message: "Image is required",
            });
            setIsLoading(false);
            window.scrollTo(0, 0);
            setTimeout(handleErrorMessageClose, 5000);
            return;
          }
        }

        let data = new Ticket();
        data.toDataSet(collectFormState(), publishStatus || "saved");

        data = JSON.parse(JSON.stringify(data));

        if (data.hasError) {
          window.scrollTo(0, 0);
          setErrorInForm({
            isError: true,
            visible: true,
            message: data.hasError.message,
          });
          setIsLoading(false);
          window.scrollTo(0, 0);
          setTimeout(handleErrorMessageClose, 5000);
        } else {
          setIsLoading(true);
          setLoadingPercentage(10);

          if (!editMode) {
            data.groupTicket.addedOn = Math.round(new Date().getTime() / 1000);

            if (
              ["Tailgate Season Pass", "Special Event"].includes(type) &&
              !matchId
            ) {
              const { downloadUrl } = await uploadTicketImage(
                imageFile,
                data.match.groupId,
              );
              data.groupTicket.image = downloadUrl;
            }
            let obj = {
              groupTicket: data.groupTicket,
              match: data.match,
              ticketType: data.groupTicket.ticketType,
              groupId: data.match.groupId,
              notifyOnPublish: notifyOnPublish,
            };

            await chantApi.post(
              `${import.meta.env.VITE_GCP_BASE_URL}/tickets/addNewGroupTicket`,
              obj,
            );

            props.router.navigate("/admin/tickets/all", {
              replace: true,
            });
          } else {
            //update

            let allTicketsValid = tickets.every(
              (ticket) => ticket.quantity >= ticket.soldTickets,
            );

            if (allTicketsValid) {
              let obj = {
                groupTicket: data.groupTicket,
                match: data.match,
                ticketId: data.ticketId,
                groupId: data.match.groupId,
                oldTicketsCount: oldTicketsCount,
                notifyOnPublish: notifyOnPublish,
              };
              if (
                ["Tailgate Season Pass", "Special Event"].includes(type) &&
                !matchId
              ) {
                if (editConfiguration.imageChanged) {
                  const { downloadUrl } = await uploadTicketImage(
                    imageFile,
                    data.match.groupId,
                    oldImageName ? oldImageName : undefined,
                  );
                  data.groupTicket.image = downloadUrl;
                } else {
                  data.groupTicket.image = imageList[0].url;
                }
              }

              await chantApi.post(
                `${import.meta.env.VITE_GCP_BASE_URL}/tickets/editSingleGroupTicket`,
                obj,
              );

              props.router.navigate("/admin/tickets/all", {
                replace: true,
              });
            } else {
              window.scrollTo(0, 0);
              setErrorInForm({
                isError: true,
                visible: true,
                message: `Quantity can not be set below the number of tickets already sold`,
              });
              setIsLoading(false);
              window.scrollTo(0, 0);
              setTimeout(handleErrorMessageClose, 5000);
            }
          }
        }
      } else {
        alert("Accept the Terms & Conditions");
      }
    } catch (error) {
      logger.error("Error submitting ticket:", error);
      setErrorInForm({
        isError: true,
        visible: true,
        message: error.message,
      });
    }
  };

  const getPaymentDetails = () => {
    fbGetGroupPaymentDetails(currentGroup).then((paymentDetails) => {
      if (paymentDetails) {
        setStripeAddress(paymentDetails.stripeAccountId);
      } else {
        setStripeAddress("");
      }
    });
  };

  const updateLimitDropdown = (value) => {
    let obj = [];
    if (type === "Tailgate Season Pass") {
      obj = Array.from(Array(50), (x, index) => index + 1);
    } else if (value > 0) {
      if (value > 20) {
        obj = Array.from(Array(20), (x, index) => index + 1);
      } else {
        let size = Number(value);
        obj = Array.from(Array(size), (x, index) => index + 1);
      }
    }
    obj.unshift(0);
    setTicketLimit(obj);
  };

  const handleInputChange = (e) => {
    if (e.target.name === "quantity") {
      updateLimitDropdown(e.target.value);
    }
    const name = e.target.name;
    const value = e.target.value;
    switch (name) {
      case "eventDescription":
        setEventDescription(value);
        break;
      case "receiptDescription":
        setReceiptDescription(value);
        break;
      case "ticketDeliveryMethodApp":
        setTicketDeliveryMethodApp(value);
        break;
      case "ticketDeliveryMethodWeb":
        setTicketDeliveryMethodWeb(value);
        break;
      case "refundTerms":
        setRefundTerms(value);
        break;
      case "contactEmail":
        setContactEmail(value);
        break;
      case "groupTerms":
        setGroupTerms(value);
        break;
      case "quantity":
        setQuantity(value);
        break;
      case "price":
        setPrice(value);
        break;
      case "section":
        setSection(value);
        break;
      case "eventName":
        setEventName(value);
        break;
      default:
        break;
    }
  };

  const handleOptionChange = (e) => {
    if (e.target.name === "matchId") {
      getMatch(e.target.value);
    }

    let value = null;
    value = e.target.value;
    if (e.target.name === "limit") {
      if (e.target.value === "NA") {
        value = 0;
      }
    }

    if (
      e.target.name === "requireMember" ||
      e.target.name === "email" ||
      e.target.name === "barcode"
    ) {
      if (String(e.target.value) === "false") {
        switch (e.target.name) {
          case "requireMember":
            setRequireMember(false);
            break;
          case "email":
            setEmail(false);
            break;
          case "barcode":
            setBarcode(false);
            break;
          default:
            break;
        }
      } else {
        switch (e.target.name) {
          case "requireMember":
            setRequireMember(true);
            break;
          case "email":
            setEmail(true);
            break;
          case "barcode":
            setBarcode(true);
            break;
          default:
            break;
        }
      }
    } else {
      switch (e.target.name) {
        case "matchId":
          setMatchId(value);
          break;
        case "type":
          setType(value);
          break;
        case "limit":
          setLimit(value);
          break;
        case "passLimit":
          setPassLimit(value);
          break;
        case "processingFee":
          setProcessingFee(value);
          break;
        default:
          break;
      }
    }

    if (e.target.name === "type") {
      if (e.target.value === "Bus" || e.target.value === "Tailgate") {
        setCheckMatchRequired(true);
        // generateBarCode: true
      } else if (
        e.target.value === "Group Match" ||
        e.target.value === "Parking"
      ) {
        setCheckMatchRequired(true);
        // generateBarCode: false,
        setEmail(true);
      } else if (e.target.value === "Tailgate Season Pass") {
        setShowRequireMembers(false);
        setCheckMatchRequired(false);
        // generateBarCode: true
      } else {
        setCheckMatchRequired(false);
        // generateBarCode: true
      }

      if (
        e.target.value === "Tailgate Season Pass" ||
        e.target.value === "Special Events"
      ) {
        syncSpecialTicketCount();
      }
    }
  };

  const handleDateChange = (name, value) => {
    if (!Array.isArray(value)) {
      value = dayjs.isDayjs(value)
        ? value
        : dayjs(value).isValid()
          ? dayjs(value)
          : "";
    }

    if (name === "eventDate" && !value) {
      setEventDate(null);
    } else if (name.includes("Time")) {
      const dateFieldName = name.replace("Time", "Date");
      let date = dateFieldName === "eventDate" ? eventDate : saleEndDate;
      if (date) {
        let currentHours = 0;
        let currentMinutes = 0;
        let seconds = 0;

        if (value) {
          if (dayjs.isDayjs(value)) {
            currentHours = value.hour();
            currentMinutes = value.minute();
          } else if (
            typeof value === "object" &&
            value.hours &&
            value.minutes
          ) {
            currentHours = value.hours();
            currentMinutes = value.minutes();
          }
        }

        let time = date
          .set("hour", currentHours)
          .set("minute", currentMinutes)
          .set("second", seconds);

        if (name === "saleEndDate" || dateFieldName === "saleEndDate") {
          if (eventDate && time.isAfter(eventDate, "day")) {
            alert("Sale end date cannot be after Event date.");
            return;
          }
        }
        if (dateFieldName === "eventDate") {
          setEventDate(time);
        } else if (dateFieldName === "saleEndDate") {
          setSaleEndDate(time);
        }
      }
    } else if (name === "showOnHomePage") {
      // handled by showOnHomePageStart/End which are not in this component's state
    } else {
      if (value) {
        if (name === "eventDate") setEventDate(value);
        else if (name === "saleEndDate") setSaleEndDate(value);
      } else {
        if (name === "eventDate") setEventDate("");
        else if (name === "saleEndDate") setSaleEndDate("");
      }
    }
  };

  const verifiedChange = (e) => {
    setAcceptedTerms(e.target.checked);
  };

  const handleTicketDetailInputChange = (e, index) => {
    if (e.target.name === "quantity") {
      let ticketsCopy = tickets;
      ticketsCopy[index].ticketLimit = Array.from(
        { length: e.target.value < 50 ? e.target.value : 50 },
        (_, index) => index + 1,
      );
      setTickets([...ticketsCopy]);
    }
    let name = e.target.name;
    let value = e.target.value;

    let ticketsCopy = tickets;
    ticketsCopy[index][name] = value;
    setTickets([...ticketsCopy]);
  };

  const handleTicketDetailDelete = (index) => {
    let ticketsCopy = tickets;
    ticketsCopy.splice(index, 1);
    setTickets([...ticketsCopy]);
  };

  const addTicket = () => {
    let ticketsCopy = tickets;
    ticketsCopy.push(JSON.parse(JSON.stringify(ticketDetailsTemplate)));
    setTickets([...ticketsCopy]);
  };

  const handleTicketDetailOptionChange = (e, index) => {
    let ticketsCopy = tickets;
    if (e.target.name === "limitPerPerson") {
      ticketsCopy[index][e.target.name] = parseInt(e.target.value)
        ? parseInt(e.target.value)
        : 0;
    } else {
      ticketsCopy[index][e.target.name] = e.target.value;
    }
    setTickets([...ticketsCopy]);
  };

  const checkChange = (e) => {
    switch (e.target.name) {
      case "showForFans":
        setShowForFans(e.target.checked);
        break;
      case "showOnWeb":
        setShowOnWeb(e.target.checked);
        break;
      case "showForMembers":
        setShowForMembers(e.target.checked);
        break;
      case "notifyOnPublish":
        setNotifyOnPublish(e.target.checked);
        break;
      default:
        break;
    }
  };

  const handleEditMode = async () => {
    let docResult = await fbGetTicketDetails(
      props.router.params.id,
      props.router.params.group,
    );

    const element = document.getElementById("quantity_error");
    if (element !== null && element?.style) {
      element.style.visibility = "hidden";
    }

    const data = new Ticket();
    data.fromDataSet(docResult.data.body.data);
    if (Array.isArray(data.imageList) && data.imageList.length > 0) {
      data.oldImageName = await getMetadata(
        ref(storage, data.imageList[0].url),
      ).then((metadata) => {
        return metadata.name;
      });
    }
    let matchListResult = [];
    if (clubId && matchList.length === 0) {
      await Axios.get(`fixtures?team=${clubId}&next=99`).then((response) => {
        let responseData = response.data.response;
        let res = [];

        if (!responseData || responseData.length === 0) return;
        responseData.forEach((fixtureData) => {
          res.push({
            fixture_id: fixtureData.fixture.id,
            league_id: fixtureData.league.id,
            league: fixtureData.league,
            event_date: fixtureData.fixture.date,
            event_timestamp: fixtureData.fixture.timestamp,
            firstHalfStart: fixtureData.fixture.periods.first,
            secondHalfStart: fixtureData.fixture.periods.second,
            round: fixtureData.league.round,
            status: fixtureData.fixture.status.long,
            statusShort: fixtureData.fixture.status.short,
            elapsed: fixtureData.fixture.status.elapsed,
            venue: fixtureData.fixture.venue.name,
            referee: fixtureData.fixture.referee,
            homeTeam: {
              team_id: fixtureData.teams.home.id,
              team_name: fixtureData.teams.home.name,
              logo: fixtureData.teams.home.logo,
            },
            awayTeam: {
              team_id: fixtureData.teams.away.id,
              team_name: fixtureData.teams.away.name,
              logo: fixtureData.teams.away.logo,
            },
            goalsHomeTeam: fixtureData.goals.home,
            goalsAwayTeam: fixtureData.goals.away,
            score: {
              halftime: fixtureData.score.halftime.home
                ? `${fixtureData.score.halftime.home}-${fixtureData.score.halftime.away}`
                : null,
              fulltime: fixtureData.score.fulltime.home
                ? `${fixtureData.score.fulltime.home}-${fixtureData.score.fulltime.away}`
                : null,
              extratime: fixtureData.score.extratime.home
                ? `${fixtureData.score.extratime.home}-${fixtureData.score.extratime.away}`
                : null,
              penalty: fixtureData.score.penalty.home
                ? `${fixtureData.score.penalty.home}-${fixtureData.score.penalty.away}`
                : null,
            },
          });
        });
        matchListResult = res;
      });
    } else {
      matchListResult = matchList;
    }

    let matchObj = null;
    matchListResult.map((m) => {
      if (String(m.fixture_id) === String(data.matchId)) {
        matchObj = m;
      }
    });

    let obj = [];
    if (data.type === "Tailgate Season Pass") {
      obj = Array.from(Array(50), (x, index) => index + 1);
    } else if (data.quantity > 0) {
      if (data.quantity > 20) {
        obj = Array.from(Array(20), (x, index) => index + 1);
      } else {
        let size = Number(data.quantity);
        obj = Array.from(Array(size), (x, index) => index + 1);
      }
    }
    obj.unshift(0);

    if (data.tickets) {
      data.tickets.forEach((ticket) => {
        ticket.ticketLimit = Array.from(
          { length: ticket.quantity },
          (_, index) => index + 1,
        );
      });
    }

    let remaining =
      docResult.data.body.data.groupTicket.totalTickets -
      docResult.data.body.data.groupTicket.remainingTickets;

    if (data.type) {
      if (type === "Tailgate Season Pass") {
        const computedEventDate =
          Array.isArray(matchList) && matchList.length === 0
            ? Math.round(Date.now() / 1000) + 100 * 24 * 60 * 60
            : matchList[matchList.length - 1].event_timestamp;

        setEventDate(computedEventDate);
      }

      setLayout2(type === "News" || type === "Update");

      // Apply ...data spread (all known state fields from Ticket model)
      setType(data.type);
      setLocation(data.location);
      setMatchId(data.matchId);
      setTitle(data.title);
      setEventDescription(data.eventDescription);
      setLastDownloadOn(data.lastDownloadOn);
      setPreviewVisible(data.previewVisible);
      setPreviewImage(data.previewImage);
      setSection(data.section);
      setQuantity(data.quantity);
      setShowRequireMembers(data.showRequireMembers);
      setPrice(data.price);
      setLimit(data.limit);
      setPassLimit(data.passLimit);
      setBarcode(data.barcode);
      setRequireMember(data.requireMember);
      setNotifyOnPublish(data.notifyOnPublish);
      setNoOfCheckins(data.noOfCheckins);
      setEditConfiguration(data.editConfiguration);
      setAcceptedTerms(data.acceptedTerms);
      setIsLoading(data.isLoading);
      // data.ticketId is undefined from fromDataSet — keep the original from route params
      setTicketId(data.ticketId ?? props.router.params.id);
      setEventName(data.eventName);
      setRow(data.row);
      setSeats(data.seats);
      setEventCode(data.eventCode);
      setCollectedAmount(data.collectedAmount);
      setRemainingTickets(data.remainingTickets);
      setBroughtBy(data.broughtBy);
      setErrorQuantity(data.errorQuantity);
      setImageFile(data.imageFile);
      setImageList(data.imageList);
      setTickets(data.tickets);
      setShowForFans(data.showForFans);
      setShowOnWeb(data.showOnWeb);
      setShowForMembers(data.showForMembers);
      setProcessingFee(data.processingFee);
      setGroupTerms(data.groupTerms);
      setReceiptDescription(data.receiptDescription);
      setTicketDeliveryMethodApp(data.ticketDeliveryMethodApp);
      setTicketDeliveryMethodWeb(data.ticketDeliveryMethodWeb);
      setContactEmail(data.contactEmail);
      setRefundTerms(data.refundTerms);
      setTicketLink(data.ticketLink);
      setOldImageName(data.oldImageName);

      if (data.type === "Bus" || data.type === "Tailgate") {
        setEmail(data.email);
        setEventTime(data.eventDate ? dayjs(data.eventDate * 1000) : null);
        setEventDate(data.eventDate ? dayjs(data.eventDate * 1000) : null);
        setSaleEndDate(
          data.saleEndDate ? dayjs(data.saleEndDate * 1000) : null,
        );
        setSaleEndTime(
          data.saleEndTime ? dayjs(data.saleEndTime * 1000) : null,
        );
        setLoadingDocument(false);
        // generateBarCode: true,
        setCheckMatchRequired(false);
        setOldTicketsCount(data.oldTicketsCount);
        setSoldTickets(remaining);
        setMatchList(matchListResult);
        setMatch(matchObj);
        setTicketLimit(obj);
      } else if (data.type === "Group Match") {
        setEmail(true);
        setEventTime(data.eventDate ? dayjs(data.eventDate * 1000) : null);
        setEventDate(data.eventDate ? dayjs(data.eventDate * 1000) : null);
        setSaleEndDate(
          data.saleEndDate ? dayjs(data.saleEndDate * 1000) : null,
        );
        setSaleEndTime(
          data.saleEndTime ? dayjs(data.saleEndTime * 1000) : null,
        );
        setLoadingDocument(false);
        // generateBarCode: false,
        setCheckMatchRequired(true);
        setOldTicketsCount(data.oldTicketsCount);
        setSoldTickets(remaining);
        setMatchList(matchListResult);
        setMatch(matchObj);
        setTicketLimit(obj);
      } else {
        setEmail(data.email);
        setEventTime(data.eventDate ? dayjs(data.eventDate * 1000) : null);
        setEventDate(data.eventDate ? dayjs(data.eventDate * 1000) : null);
        setSaleEndDate(
          data.saleEndDate ? dayjs(data.saleEndDate * 1000) : null,
        );
        setSaleEndTime(
          data.saleEndTime ? dayjs(data.saleEndTime * 1000) : null,
        );
        setLoadingDocument(false);
        // generateBarCode: true,
        setCheckMatchRequired(false);
        setOldTicketsCount(data.oldTicketsCount);
        setSoldTickets(remaining);
        setMatchList(matchListResult);
        setMatch(matchObj);
        setTicketLimit(obj);
      }
    } else {
      setEmail(data.email);
      setEventTime(data.eventDate ? dayjs(data.eventDate * 1000) : null);
      setEventDate(data.eventDate ? dayjs(data.eventDate * 1000) : null);
      setSaleEndDate(data.saleEndDate ? dayjs(data.saleEndDate * 1000) : null);
      setSaleEndTime(data.saleEndTime ? dayjs(data.saleEndTime * 1000) : null);
      setLoadingDocument(false);
      setOldTicketsCount(data.oldTicketsCount);
      setSoldTickets(remaining);
      setMatchList(matchListResult);
      setMatch(matchObj);
      setTicketLimit(obj);
    }
  };

  const getMatch = (id) => {
    let hours = 0,
      minutes = 0,
      seconds = 59;

    let date = null;
    let matchObj = null;
    let loc = "";
    matchList.map((m) => {
      if (String(m.fixture_id) === String(id)) {
        date = m.event_date;
        loc = { address: m.venue };
        matchObj = m;
      }
    });

    if (date) {
      if (type === "Group Match" || type === "Parking") {
        setSaleEndDate(dayjs(date));
        setSaleEndTime(dayjs(date));
        setEventDate(dayjs(date));
        setEventTime(dayjs(date));
        setLocation(loc);
        setMatch(matchObj);
      } else {
        setSaleEndTime(
          dayjs(date).set({
            h: hours,
            m: minutes,
            second: seconds,
          }),
        );
        setSaleEndDate(
          dayjs(date).set({
            h: hours,
            m: minutes,
            second: seconds,
          }),
        );
        setEventDate(
          dayjs(date).set({
            h: hours,
            m: minutes,
            second: seconds,
          }),
        );
        setEventTime(
          dayjs(date).set({
            h: hours,
            m: minutes,
            second: seconds,
          }),
        );
        setMatch(matchObj);
      }
    }
  };

  const getMatchList = (isPrevGroupDifferent = false) => {
    if (clubId && (isPrevGroupDifferent || matchList.length === 0)) {
      Axios.get(`fixtures?team=${clubId}&next=99`).then((response) => {
        let data = response.data.response;
        let res = [];
        data.forEach((fixtureData) => {
          res.push({
            fixture_id: fixtureData.fixture.id,
            league_id: fixtureData.league.id,
            league: fixtureData.league,
            event_date: fixtureData.fixture.date,
            event_timestamp: fixtureData.fixture.timestamp,
            firstHalfStart: fixtureData.fixture.periods.first,
            secondHalfStart: fixtureData.fixture.periods.second,
            round: fixtureData.league.round,
            status: fixtureData.fixture.status.long,
            statusShort: fixtureData.fixture.status.short,
            elapsed: fixtureData.fixture.status.elapsed,
            venue: fixtureData.fixture.venue.name,
            referee: fixtureData.fixture.referee,
            homeTeam: {
              team_id: fixtureData.teams.home.id,
              team_name: fixtureData.teams.home.name,
              logo: fixtureData.teams.home.logo,
            },
            awayTeam: {
              team_id: fixtureData.teams.away.id,
              team_name: fixtureData.teams.away.name,
              logo: fixtureData.teams.away.logo,
            },
            goalsHomeTeam: fixtureData.goals.home,
            goalsAwayTeam: fixtureData.goals.away,
            score: {
              halftime: fixtureData.score.halftime.home
                ? `${fixtureData.score.halftime.home}-${fixtureData.score.halftime.away}`
                : null,
              fulltime: fixtureData.score.fulltime.home
                ? `${fixtureData.score.fulltime.home}-${fixtureData.score.fulltime.away}`
                : null,
              extratime: fixtureData.score.extratime.home
                ? `${fixtureData.score.extratime.home}-${fixtureData.score.extratime.away}`
                : null,
              penalty: fixtureData.score.penalty.home
                ? `${fixtureData.score.penalty.home}-${fixtureData.score.penalty.away}`
                : null,
            },
          });
        });
        setMatchList(res);
        setLoadingMatches(false);
      });
    }
  };

  const syncSpecialTicketCount = async () => {
    let groupId = currentGroup;
    try {
      const timezone = "America/Panama";
      const now = dayjs().tz(timezone).unix();
      const ticketsDocs = await getDocs(
        query(
          collection(db, "tickets", groupId, "ticket"),
          where("match.fixtureId", "==", 0),
          where("groupTicket.eventDate", ">=", now),
        ),
      );
      let count = 0;
      ticketsDocs.docs.forEach((ticket) => {
        count += ticket.data().groupTicket.remainingTickets;
      });
      await setDoc(doc(db, "matchDay", groupId, "matches", "0"), {
        ticketCount: count,
      });
    } catch (error) {
      logger.log(error);
    }
  };

  // ─── Effects ───

  // checkError moved to useEffect (was called in render() in class)
  useEffect(() => {
    const element = document.getElementById("quantity_error");
    if (element !== null && element?.style) {
      if (quantity < soldTickets) {
        element.style.visibility = "visible";
        if (quantity !== null) {
          setQuantity(null);
        }
      } else {
        element.style.visibility = "hidden";
      }
    }
  }, [quantity, soldTickets]);

  // componentDidMount + componentDidUpdate(prevProps.currentGroup)
  useEffect(() => {
    const isMount = isFirstRunRef.current;
    isFirstRunRef.current = false;

    if (isMount) {
      // componentDidMount
      if (props.router.params.id) {
        if (currentGroup === props.router.params.group) {
          handleEditMode();
        }
      } else {
        setLoadingDocument(false);
      }
      getPaymentDetails();
      getMatchList(false); // only fetches if matchList.length === 0
      getLocations(currentGroup).then((locations) => {
        setAllLocations(locations);
      });
    } else {
      // componentDidUpdate: currentGroup changed
      if (props.router.params.id && loadingDocument) {
        handleEditMode();
      }
      getPaymentDetails();
      getMatchList(true); // always fetch if clubId
      getLocations(currentGroup).then((locations) => {
        setAllLocations(locations);
      });
    }
  }, [currentGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── Computed: tickets with ticketLimit ───
  let ticketsToRender = tickets;
  if (ticketsToRender.length > 0) {
    ticketsToRender.forEach((ticket) => {
      if (ticket.quantity > 0) {
        ticket.ticketLimit = Array.from(
          { length: ticket.quantity < 50 ? ticket.quantity : 50 },
          (_, index) => index + 1,
        );
      }
    });
  }

  return {
    // Store data
    currentGroup,
    adminData,
    clubId,

    // State
    type,
    location,
    matchId,
    title,
    eventDate,
    saleEndDate,
    eventDescription,
    checkMatchRequired,
    section,
    quantity,
    price,
    limit,
    passLimit,
    stripeAddress,
    notifyOnPublish,
    errorInForm,
    soldTickets,
    loadingDocument,
    editMode,
    editConfiguration,
    ticketTypes,
    processingFeeTypes,
    ticketLimit,
    matchList,
    acceptedTerms,
    match,
    isLoading,
    loadingMatches,
    eventName,
    remainingTickets,
    imageFile,
    imageList,
    tickets,
    ticketsToRender,
    showForFans,
    showOnWeb,
    showForMembers,
    processingFee,
    groupTerms,
    receiptDescription,
    allLocations,
    ticketDeliveryMethodApp,
    ticketDeliveryMethodWeb,
    contactEmail,
    refundTerms,
    layout2,

    // Handlers
    uploadAction,
    handleImageChange,
    handleErrorMessageClose,
    handleSubmit,
    handleInputChange,
    handleOptionChange,
    handleDateChange,
    verifiedChange,
    handleTicketDetailInputChange,
    handleTicketDetailDelete,
    addTicket,
    handleTicketDetailOptionChange,
    checkChange,

    // Setters needed by sub-components
    setLocation,
  };
};

export default useCreateTicket;
